// Activity gap (care alert): a group with children present has had no entry for longer
// than the org's threshold. One workflow item of category activity_gap per group and
// day. No child is named. Shared by the inbox row summary and the detail renderer.
// The duration reads and formats like the diaper check's (same minutes, same words).

import { diaperCheckMinutes, formatDiaperDuration } from './diaperCheck';

interface TranslateWithValues {
  _: (d: { id: string; message: string; values?: Record<string, unknown> }) => string;
}

function readString(payload: Record<string, unknown> | undefined, key: string): string | undefined {
  const value = payload?.[key];
  return typeof value === 'string' && value.trim() ? value : undefined;
}

/** "for 2 h 15 min without an entry", or undefined when `since` is missing. */
export function activityGapDurationLine(
  i18n: TranslateWithValues,
  payload: Record<string, unknown> | undefined,
  now: Date = new Date(),
): string | undefined {
  const minutes = diaperCheckMinutes(payload, now);
  if (minutes === undefined) return undefined;
  return i18n._({
    id: 'workflow.activityGap.durationLine',
    message: 'for {duration} without an entry',
    values: { duration: formatDiaperDuration(i18n, minutes) },
  });
}

/** The inbox and board line: "Igel · for 2 h 15 min without an entry". */
export function activityGapSummary(
  i18n: TranslateWithValues,
  payload: Record<string, unknown> | undefined,
  now: Date = new Date(),
): string | undefined {
  const parts = [readString(payload, 'group_name'), activityGapDurationLine(i18n, payload, now)].filter(
    (part): part is string => Boolean(part),
  );
  return parts.length > 0 ? parts.join(' · ') : undefined;
}
